var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "competitor-list" }, [_c('table-list', { ref: "table", attrs: { "list": _vm.innerList, "columnConfig": _vm.filterColumnConfig, "tableConfig": _vm.tableConfig }, on: { "selection-change": _vm.handleSelectionChange } }, [_vm._t("action-cell", null, { "slot": "action-cell" })], 2)], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };